/*
 * @Author: nsj
 * @Date: 2021-03-02 13:42:44
 * @Description: description
 */
const HomePage = () => import( /* webpackChunkName: "HomePage" */ '../pages/HomePage')
const LoginPage = () => import( /* webpackChunkName: "LoginPage" */ '../pages/LoginPage')
const DoctorManagement = () => import( /* webpackChunkName: "DoctorManagement" */ '../pages/DoctorManagement')
const DoctorScheduling = () => import( /* webpackChunkName: "DoctorScheduling" */ '../pages/DoctorScheduling')
const DataTable = () => import( /* webpackChunkName: "DataTable" */ '../pages/DataTable')
const DoctorFirstPage = () => import( /* webpackChunkName: "DoctorFirstPage" */ '../pages/DoctorFirstPage')
const BaseDoctorPage = () => import( /* webpackChunkName: "BaseDoctorPage" */ '../pages/BaseDoctorPage')
const FollowupManagement = () => import( /* webpackChunkName: "FollowupManagement" */ '../pages/FollowupManagement')
const CaseDiscussion = () => import( /* webpackChunkName: "CaseDiscussion" */ '../pages/CaseDiscussion')
const NewCase = () => import( /* webpackChunkName: "NewCase" */ '../pages/NewCase')
const CaseDetail = () => import( /* webpackChunkName: "CaseDetail" */ '../pages/CaseDetail')
const AccountManage = () => import( /* webpackChunkName: "AccountManage" */ '../pages/AccountManage')
const PersonalInformation = () => import( /* webpackChunkName: "PersonalInformation" */ '../pages/PersonalInformation')
const ExpertTeamInformation = () => import( /* webpackChunkName: "ExpertTeamInformation" */ '../pages/ExpertTeamInformation')
const AcademicCommunity = () => import( /* webpackChunkName: "AcademicCommunity" */ '../pages/AcademicCommunity')
const ArticleDetails = () => import( /* webpackChunkName: "ArticleDetails" */ '../pages/ArticleDetails')
const MyArticles = () => import( /* webpackChunkName: "MyArticles" */ '../pages/MyArticles')
const Register = () => import( /* webpackChunkName: "Register" */ '../pages/Register')
const Loading = () => import( /* webpackChunkName: "Loading" */ '../pages/Loading')
const OperationGuide = () => import( /* webpackChunkName: "OperationGuide" */ '../pages/OperationGuide')
const DoctorManagementCenter = () => import( /* webpackChunkName: "DoctorManagementCenter" */ '../pages/DoctorManagementCenter')
const logPage = () => import( /* webpackChunkName: "logPage" */ '../pages/logPage')
const pdfTest = () => import( /* webpackChunkName: "pdfTest" */ '../pages/pdfTest')
const TerminalSetting = () => import( /* webpackChunkName: "TerminalSetting" */ '../pages/TerminalSetting')

const routes = [
    { path: '/', redirect: '/LoginPage' },
    { path: '/LoginPage', name: 'LoginPage', component: LoginPage },  //登录页面
    { path: '/Register', name: 'Register', component: Register },//注册页面
    { path: '/Loading/:type', name: 'Loading', component: Loading },//anymed跳转中转页
    {
        path: '/HomePage',
        name: 'HomePage',
        component: HomePage,
        children: [
            { path: 'DoctorManagement', name: 'DoctorManagement', component: DoctorManagement },     // 医生管理页面
            { path: 'DoctorScheduling', name: 'DoctorScheduling', component: DoctorScheduling },     // 医生排班页面
            { path: 'DataTable', name: 'DataTable', component: DataTable },     // 平台首页
            { path: 'DoctorFirstPage', name: 'DoctorFirstPage', component: DoctorFirstPage },     // 医生首页
            { path: 'FollowupManagement', name: 'FollowupManagement', component: FollowupManagement }, //随访管理
            { path: 'CaseDiscussion/:tab', name: 'CaseDiscussion', component: CaseDiscussion },    //案例讨论
            { path: 'NewCase', name: 'NewCase', component: NewCase },//新建案例页
            { path: 'CaseDetail/:id/:tabName', name: 'CaseDetail', component: CaseDetail },//案例详情页
            { path: 'AccountManage', name: 'AccountManage', component: AccountManage },//平台账号管理页面
            { path: 'PersonalInformation', name: 'PersonalInformation', component: PersonalInformation },//个人信息页面
            { path: 'ExpertTeamInformation', name: 'ExpertTeamInformation', component: ExpertTeamInformation },//专家团队信息页面
            { path: 'AcademicCommunity', name: 'AcademicCommunity', component: AcademicCommunity },//学术社区页面
            { path: 'ArticleDetails', name: 'ArticleDetails', component: ArticleDetails },//文章详情页面
            { path: 'MyArticles', name: 'MyArticles', component: MyArticles },//我的文章页面
            { path: 'OperationGuide', name: 'OperationGuide', component: OperationGuide },//远程手术指导页面
            { path: 'BaseDoctorPage', name: 'BaseDoctorPage', component: BaseDoctorPage },//基层医生的首页
            { path: 'DoctorManagementCenter', name: 'DoctorManagementCenter', component: DoctorManagementCenter },//中心医生的医生管理页面
            { path: 'logPage', name: 'logPage', component: logPage },//中心医生的医生管理页面
            { path: 'pdfTest', name: 'pdfTest', component: pdfTest }, //中心医生的医生管理页面
            { path: 'TerminalSetting', name: 'TerminalSetting', component: TerminalSetting }, //医技终端管理
        ]
    },

]

export default routes